<section class="completed-card">
  <h1>Anruf beendet</h1>
  <p>Die Sitzung wurde abgeschlossen.</p>
  @if (inquiryId) {
    <p class="inquiry-id">Inquiry: {{ inquiryId }}</p>
  }
</section>
